<template>
  <div>
    <div class="tw-border-b tw-border-b-primary-grey-200 tw-mb-4">
      <div class="tw-flex tw-justify-between tw-items-start">
        <cb-icon-mail-lock
          :width="48"
          color="currentColor"
          class="tw-mb-4 tw-p-2 tw-bg-primary-grey-50 tw-rounded-lg"
        />
        <span
          class="tw-text-xs tw-bg-system-warning-100 tw-px-2 tw-py-1 tw-rounded-xl"
          >{{ t("recommended") }}</span
        >
      </div>
      <p class="tw-text-lg tw-font-medium tw-mb-4">
        {{ t("prevent-conflicts") }}
      </p>
      <p class="tw-mb-4">
        {{ t("using-spamtitan") }}
      </p>
    </div>
    <div class="tw-flex tw-justify-end">
      <cl-button variant="secondary" @onClick="isSlideOutOpen = true">
        {{ t("learn-how") }}
      </cl-button>
    </div>
  </div>
  <emailSecurityConflictsSlideoutIndex v-model="isSlideOutOpen" />
</template>
<script setup lang="ts">
import { ref } from "vue";
import emailSecurityConflictsSlideoutIndex from "./email-security-conflicts-slideout/email-security-conflicts-slideout.index.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const isSlideOutOpen = ref(false);
</script>
